import React from 'react';
import styled from 'styled-components';

const Title = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #41526A;
  line-height: 15px;
  padding-bottom: 16px;
`;

export default Title;
